import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgYoutube = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 73 58"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M59.461 1.582a168.7 168.7 0 0 0-46.102 0C7.078 2.453 2.187 7.23 1.2 13.48A96.6 96.6 0 0 0 0 28.68c0 5.077.41 10.237 1.21 15.28.97 6.102 5.97 10.95 12.142 11.81a168 168 0 0 0 46.102 0c6.27-.872 11.148-5.61 12.14-11.81.802-5.039 1.212-10.18 1.212-15.28 0-5.102-.41-10.239-1.211-15.282C70.626 7.296 65.626 2.45 59.454 1.59zM67.65 43.32c-.711 4.441-4.22 7.852-8.739 8.48a164.7 164.7 0 0 1-45 0c-4.449-.62-8.039-4.101-8.738-8.48a93.4 93.4 0 0 1-1.16-14.648c0-4.89.39-9.77 1.148-14.57.711-4.488 4.23-7.93 8.762-8.559 7.43-1.03 15-1.55 22.5-1.55s15.07.52 22.5 1.55c4.45.622 8.04 4.102 8.738 8.48a93.4 93.4 0 0 1 1.16 14.649c0 4.89-.39 9.82-1.16 14.648z"
    />
    <path
      fill="currentColor"
      d="M49.43 26.942 28.59 14.911a2 2 0 0 0-3 1.73v24.06a1.99 1.99 0 0 0 1 1.73c.308.18.648.27 1 .27.351 0 .691-.09 1-.27L49.43 30.4a2 2 0 0 0 0-3.461zM29.59 37.243V20.102l14.84 8.57z"
    />
  </svg>
);
export default SvgYoutube;
